import {constants} from '../../../redux/constants'
import {ITaskState} from './reducers'
import {ComponentEnum} from '../componentsRegistry/Registry'
import {WindowEnum} from '../domain/IWindow'

export const taskActions = {
  clearState: () => ({
    type: constants.CLEAR_TASK_STATE,
  }),

  setState: (state: ITaskState) => ({
    type: constants.SET_TASK_STATE,
    state,
  }),

  setActiveInWindow: (positionKey: WindowEnum, activeComponentId: ComponentEnum, isUnCollapse?: boolean) => ({
    type: constants.SET_WINDOW,
    positionKey,
    level1Key: 'activeComponentId',
    payload: activeComponentId,
    isUnCollapse,
  }),
  setCollapsedInWindow: (positionKey: WindowEnum, isCollapsed: boolean) => ({
    type: constants.SET_WINDOW,
    positionKey,
    level1Key: 'isCollapsed',
    payload: isCollapsed,
  }),
  setInnerActiveInWindow: (
    positionKey: WindowEnum,
    tabKey: 'first' | 'second' | 'third',
    innerActiveComponentId: ComponentEnum,
  ) => ({
    type: constants.SET_WINDOW,
    positionKey,
    level1Key: 'tab',
    level2Key: tabKey,
    level3Key: 'innerActiveComponentId',
    payload: innerActiveComponentId,
  }),

  changeFullscreenMode: (
    isFullscreenMode,
    isSplitMode,
    fullscreenLeftComponentId,
    fullscreenRightComponentId,
    fullscreenActiveLeftComponentId,
    fullscreenActiveRightComponentId,
  ) => ({
    type: constants.SET_TASK_STATE,
    state: {
      isFullscreenMode,
      isSplitMode,
      fullscreenLeftComponentId,
      fullscreenRightComponentId,
      fullscreenActiveLeftComponentId,
      fullscreenActiveRightComponentId,
    },
  }),

  setFullscreenActiveLeftComponentId: (componentId: ComponentEnum) => ({
    type: constants.SET_TASK_STATE,
    state: {
      fullscreenActiveLeftComponentId: componentId,
    },
  }),

  setFullscreenActiveRightComponentId: (componentId: ComponentEnum) => ({
    type: constants.SET_TASK_STATE,
    state: {
      fullscreenActiveRightComponentId: componentId,
    },
  }),

  changeDrawerModal: (isOpen, componentId) => ({
    type: constants.SET_TASK_STATE,
    state: {
      isDrawerModalOpen: isOpen,
      drawerModalComponentId: componentId,
    },
  }),

  getTask: (taskId) => ({
    type: constants.GET_TASK,
    uri: '/course/task/' + taskId,
  }),

  getThemeTasks: (taskId) => ({
    type: constants.GET_API_TASK,
    uri: '/course/task/theme/' + taskId,
    propId: 'themeTasks',
  }),

  getSchemaDescription: () => ({
    type: constants.GET_API_TASK,
    uri: '/course/schema-description',
    propId: 'schemaDescription',
  }),

  getAnswerView: (taskId: number) => ({
    type: constants.GET_API_ANSWER_VIEW,
    uri: '/course/task/answer-view/' + taskId,
  }),

  setContainerHeight: (height: number) => ({
    type: constants.SET_TASK_CONTAINER_HEIGHT,
    height,
  }),
}
